import fetch, { parseResponse } from "./fetch";

class Language {
    list(languageCode: string) {
        return parseResponse<HashMap<string>>(fetch.get(`language/all/${languageCode}`));
    }
}

export default new Language();
